import type { ComponentProps } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";

type CardProps = ComponentProps<"div"> & { asChild?: boolean };

export function Card({ className, asChild = false, ...props }: CardProps) {
  // Most surfaces this replaced were sectioning elements rather than divs, and
  // a card is a box drawn around content, not a reason to change what the
  // content is.
  const Component = asChild ? Slot : "div";
  return (
    <Component
      className={cn(
        "rounded-lg border border-border bg-card text-card-foreground",
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: ComponentProps<"div">) {
  return (
    <div className={cn("flex flex-col gap-1 p-4", className)} {...props} />
  );
}

export function CardTitle({ className, ...props }: ComponentProps<"h3">) {
  return (
    // Children arrive through the prop spread, which the rule cannot follow.
    // eslint-disable-next-line jsx-a11y/heading-has-content
    <h3
      className={cn("text-base font-semibold leading-tight", className)}
      {...props}
    />
  );
}

export function CardDescription({ className, ...props }: ComponentProps<"p">) {
  return (
    <p
      className={cn("text-xs text-neutral-foreground", className)}
      {...props}
    />
  );
}

export function CardContent({ className, ...props }: ComponentProps<"div">) {
  return <div className={cn("p-4 pt-0", className)} {...props} />;
}

export function CardFooter({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn("flex items-center gap-2 p-4 pt-0", className)}
      {...props}
    />
  );
}
